var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _path9, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 256 256",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#cecece",
    height: 151.106,
    rx: 13.665,
    width: 219.26,
    x: 18.37,
    y: 31.283
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.37 168.724v-123.776a13.681 13.681 0 0 1 13.665-13.665h-10a13.681 13.681 0 0 0 -13.665 13.665v123.776a13.681 13.681 0 0 0 13.665 13.665h10a13.681 13.681 0 0 1 -13.665-13.665z",
    fill: "#afafaf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m227.63 168.724v-123.776a13.681 13.681 0 0 0 -13.665-13.665h10a13.681 13.681 0 0 1 13.665 13.665v123.776a13.681 13.681 0 0 1 -13.665 13.665h-10a13.681 13.681 0 0 0 13.665-13.665z",
    fill: "#e2e2e2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#63bce7",
    height: 122.288,
    rx: 5.256,
    width: 202.442,
    x: 26.779,
    y: 39.692
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.779 156.724v-111.777a5.271 5.271 0 0 1 5.256-5.256h-10a5.271 5.271 0 0 0 -5.256 5.256v111.777a5.271 5.271 0 0 0 5.256 5.256h10a5.271 5.271 0 0 1 -5.256-5.256z",
    fill: "#6377e7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m219.221 156.724v-111.777a5.271 5.271 0 0 0 -5.256-5.256h10a5.271 5.271 0 0 1 5.256 5.256v111.777a5.271 5.271 0 0 1 -5.256 5.256h-10a5.271 5.271 0 0 0 5.256-5.256z",
    fill: "#63e2e7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m89.809 204.547h76.383v9.197h-76.383z",
    fill: "#9e9e9e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m89.809 204.547h10v9.197h-10z",
    fill: "#707070"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m100.67 182.389h54.659v22.158h-54.659z",
    fill: "#cecece"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m100.67 182.389h10v22.158h-10z",
    fill: "#afafaf"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 172.184,
    fill: "#9e9e9e",
    r: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 100.836,
    fill: "#f46275",
    r: 47
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 100.836,
    fill: "#cecece",
    r: 22.336
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 100.836,
    fill: "#f8af23",
    r: 8.502
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m163.297 56.35 2.558 6.631 6.631 2.557 13.555-13.555-8.309-.88-.88-8.309z",
    fill: "#cecece"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.721 156.724v-111.777a6.763 6.763 0 0 0 -6.755-6.756h-191.932a6.763 6.763 0 0 0 -6.755 6.756v111.777a6.763 6.763 0 0 0 6.755 6.756h191.932a6.763 6.763 0 0 0 6.755-6.756zm-202.441 0v-111.777a3.76 3.76 0 0 1 3.755-3.756h191.931a3.76 3.76 0 0 1 3.755 3.756v111.777a3.76 3.76 0 0 1 -3.755 3.756h-191.932a3.76 3.76 0 0 1 -3.755-3.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 166.185a6 6 0 1 0 6 6 6.007 6.007 0 0 0 -6-6zm0 9a3 3 0 1 1 3-3 3 3 0 0 1 -3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.323 223.217h-18a1.5 1.5 0 0 0 0 3h18a1.5 1.5 0 1 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.68 223.217h-18a1.5 1.5 0 0 0 0 3h18a1.5 1.5 0 0 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.479 223.217h-180.958a1.5 1.5 0 0 0 0 3h180.958a1.5 1.5 0 0 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.32 215.244h237.36a1.5 1.5 0 0 0 0-3h-78.989v-7.7a1.5 1.5 0 0 0 -1.5-1.5h-9.362v-19.155h67.137a15.182 15.182 0 0 0 15.164-15.165v-123.777a15.181 15.181 0 0 0 -15.164-15.164h-191.932a15.181 15.181 0 0 0 -15.164 15.164v123.777a15.182 15.182 0 0 0 15.164 15.165h67.137v19.158h-9.362a1.5 1.5 0 0 0 -1.5 1.5v7.7h-78.989a1.5 1.5 0 0 0 0 3zm10.55-46.521v-123.776a12.178 12.178 0 0 1 12.164-12.164h191.932a12.178 12.178 0 0 1 12.164 12.164v123.777a12.178 12.178 0 0 1 -12.164 12.165h-191.932a12.178 12.178 0 0 1 -12.164-12.165zm82.3 15.165h51.658v19.158h-51.657zm-10.861 22.159h73.383v6.2h-73.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.2 50.492-7.1-.753-.753-7.1a1.5 1.5 0 0 0 -2.552-.9l-13.559 13.55a1.5 1.5 0 0 0 -.339 1.6l2.203 5.721-2.912 2.912a48.585 48.585 0 1 0 2.121 2.121l2.912-2.912 5.72 2.207a1.5 1.5 0 0 0 1.6-.339l13.559-13.555a1.5 1.5 0 0 0 -.9-2.552zm-12.7 50.344a45.578 45.578 0 1 1 -14.427-33.194l-15.324 15.324a23.876 23.876 0 1 0 2.121 2.121l15.323-15.324a45.323 45.323 0 0 1 12.307 31.073zm-38.5 0a7.023 7.023 0 1 1 -3.231-5.892l-4.831 4.831a1.5 1.5 0 1 0 2.121 2.121l4.831-4.831a6.954 6.954 0 0 1 1.11 3.771zm-1.08-8.043a10.043 10.043 0 1 0 2.121 2.122l7.694-7.694a20.9 20.9 0 1 1 -2.121-2.121zm38.194-29.006-5.1-1.967-1.968-5.1 10.644-10.643.55 5.185a1.5 1.5 0 0 0 1.333 1.333l5.185.55z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService04);
export default __webpack_public_path__ + "static/media/service04.5f37dfacecbb3aa1035a01118029c645.svg";
export { ForwardRef as ReactComponent };